
export default {
  name: 'SearchBanner'
}
